<template>
  <div ref="buyMediaModal" class="modal modal-v modal-v--normal fade" id="imagePaymentModal" tabindex="-1" role="dialog" aria-labelledby="imagePaymentModalLabel" aria-hidden="true">
    <div class="modal-dialog " role="document">

      <div class="modal-content">
        <div class="modal-body">
          <div class="profile-image">
            <div class="profile-image__box"></div>
            <div class="profile-image__box"></div>
            <img v-if="media" class="profile-show__modal-avatar" :src="media.url+'?p=small'" alt="">
            <div class="profile-image__box"></div>
            <div class="profile-image__box"></div>
          </div>
          <div class="title coins">
            <span v-if="media" class="js-price">{{ media.price }}</span>
            <img src="../../images/others/coin.svg" alt="" class="coin-icon">

          </div>
          <h2 class="title">
            {{ trans.get('profile:show.image_buy_modal.header') }}
          </h2>
          <p class="desc">
            {{ trans.get('profile:show.image_buy_modal.desc') }}
          </p>
          <div v-if="false" class="checkbox-standard pull-left">
            <label>
              <input v-model="agreement" name="agreement" type="checkbox">
              <span class="checkbox-standard__box checkbox-standard__box--small mr-2"></span>
              <span class="desc desc--small">
                                {{ trans.get('profile:show.image_buy_modal.dont_show_modal_anymore') }}
                            </span>
            </label>
          </div>
          <div class="buttons">
            <button type="button" class="button button__text-icon button__text-icon--reverse" data-dismiss="modal">
              <i class="demo-icon icon-close"></i>
              <span>
                                {{ trans.get('profile:show.image_buy_modal.close_button') }}
                            </span>
            </button>
            <button type="button" class="button button--primary" @click="unlock">
              {{ trans.get('profile:show.image_buy_modal.unlock_button') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';


export default {
  name: 'BuyMediaModal',
  props: {},
  data() {
    return {
      agreement: true,
      open: false,
      media: null,
      form: {},
      profileId: null,
      avatarUrl: null,
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
      isPaymentApproved: 'isPaymentApproved',
    }),
  },
  watch: {
    open(val) {
      if (val) {
        if (this.media.price > (this.user.coins + this.user.free_coins)) {
          this.open = false;
          this.$eventHub.$emit('EventPopupModalOpen', this.globals.actions.ACTION_NOT_ENOUGH_COINS);
          return false;
        }

        if (this.isPaymentApproved(window.globals.user.payment_approval_media)) {
          this.unlock();
        } else {
          $(this.$refs.buyMediaModal).modal('show');
        }
      } else {
        $(this.$refs.buyMediaModal).modal('hide');
        this.profileId = null;
        this.form = {};
      }
    },
  },
  methods: {
    unlock() {
      axios.post(zRoute('ajax.profiles.media.store'), {
        media_id: this.media.id,
        agreement: this.agreement,
      }).then(response => {
        this.$eventHub.$emit('FreshMedia', response.data.data);
        this.open = false;
      }).catch(error => {
        if (error.response.data.reason === window.globals.actions.ACTION_NOT_ENOUGH_COINS) {
          this.open = false;
        }
        if (error.response.data.reason === window.globals.actions.ACTION_PAYWALL_PAYMENT) {
          this.open = false;
        }
      });
    },
  },
  mounted() {
    let vm = this;
    $(this.$refs.buyMediaModal).on('hidden.bs.modal', function (e) {
      vm.open = false;
    });

    this.$eventHub.$on('BuyMediaModalOpen', (media) => {
      vm.open = true;
      vm.media = media;
    });
  }
};
</script>

<style scoped>

</style>
